import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-cont"},[_c(VAutocomplete,{attrs:{"label":"Clause","items":_vm.clauseList,"item-value":"id","item-text":"clause"},model:{value:(_vm.clause),callback:function ($$v) {_vm.clause=$$v},expression:"clause"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }